var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unread-badge-wrapper"},[_c('v-btn',{staticClass:"message-btn",attrs:{"text":""},on:{"click":_vm.handleClick}},[_c('v-badge',{staticClass:"message-badge",attrs:{"content":_vm.displayCount,"value":_vm.unreadCount > 0,"color":"red","offset-x":10,"offset-y":10}},[_c('v-icon',[_vm._v("mdi-message-outline")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }